export function Mark() {
  return (
    <img
      src="/images/logo.svg"
      alt=""
      aria-hidden
      className="size-10 shrink-0 object-contain"
    />
  );
}
export function Arrow() {
  return (
    <svg
      aria-hidden
      viewBox="0 0 16 16"
      fill="none"
      className="size-4 shrink-0 transition-transform duration-300 group-hover:translate-x-1"
    >
      <path
        d="M2 8h11M9 4l4 4-4 4"
        stroke="currentColor"
        strokeWidth="1.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export function ChevronDown() {
  return (
    <svg aria-hidden viewBox="0 0 16 16" fill="none" className="size-4">
      <path
        d="m4 6 4 4 4-4"
        stroke="currentColor"
        strokeWidth="1.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export function Check() {
  return (
    <span
      aria-hidden
      className="grid size-5 place-items-center rounded-full bg-leaf text-ink text-xs font-black leading-none"
    >
      ✓
    </span>
  );
}

export function RuntimeMark({
  type,
}: {
  type: "php" | "node" | "python" | "install";
}) {
  if (type !== "install") {
    const logos = {
      php: "/images/runtime-logos/php.svg",
      node: "/images/runtime-logos/nodejs.svg",
      python: "/images/runtime-logos/python.svg",
    } as const;
    return (
      <span
        aria-hidden
        className="grid size-15 place-items-center rounded-[1.1rem] bg-white p-3 shadow-[3px_3px_0_#a8f35a]"
      >
        <img src={logos[type]} alt="" className="size-full object-contain" />
      </span>
    );
  }

  return (
    <span
      aria-hidden
      className="grid size-15 place-items-center rounded-[1.1rem] bg-leaf text-ink shadow-[3px_3px_0_#1d654f]"
    >
      <svg viewBox="0 0 24 24" fill="none" className="size-7">
        <rect x="4" y="4" width="6" height="6" rx="1.5" fill="currentColor" />
        <rect x="14" y="4" width="6" height="6" rx="1.5" fill="currentColor" />
        <rect x="4" y="14" width="6" height="6" rx="1.5" fill="currentColor" />
        <path
          d="m16.5 13.5-.8 2.1-2.2.8 2.2.8.8 2.2.8-2.2 2.2-.8-2.2-.8-.8-2.1Z"
          fill="currentColor"
        />
      </svg>
    </span>
  );
}

export function HostingStackIcon({
  type,
}: {
  type: "email" | "database" | "domain" | "backup" | "schedule" | "redis";
}) {
  return (
    <span
      aria-hidden
      className="grid size-9 shrink-0 place-items-center rounded-full bg-cloud text-moss"
    >
      {type === "email" ? (
        <svg viewBox="0 0 24 24" fill="none" className="size-5">
          <rect
            x="3.5"
            y="5.5"
            width="17"
            height="13"
            rx="2"
            stroke="currentColor"
            strokeWidth="1.8"
          />
          <path
            d="m5 7 7 5 7-5"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ) : type === "database" ? (
        <svg viewBox="0 0 24 24" fill="none" className="size-5">
          <ellipse
            cx="12"
            cy="6"
            rx="6.5"
            ry="2.8"
            stroke="currentColor"
            strokeWidth="1.8"
          />
          <path
            d="M5.5 6v6c0 1.6 2.9 2.8 6.5 2.8s6.5-1.2 6.5-2.8V6m-13 6v6c0 1.6 2.9 2.8 6.5 2.8s6.5-1.2 6.5-2.8v-6"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
          />
        </svg>
      ) : type === "domain" ? (
        <svg viewBox="0 0 24 24" fill="none" className="size-5">
          <circle
            cx="10"
            cy="11"
            r="6.5"
            stroke="currentColor"
            strokeWidth="1.8"
          />
          <path
            d="M3.5 11h13M10 4.5c1.8 1.8 2.7 4 2.7 6.5S11.8 15.7 10 17.5c-1.8-1.8-2.7-4-2.7-6.5S8.2 6.3 10 4.5Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
          />
          <path
            d="m16.5 15.5 1.3 1.3 2.7-3"
            stroke="#a8f35a"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ) : type === "backup" ? (
        <svg viewBox="0 0 24 24" fill="none" className="size-5">
          <path
            d="M18.5 9A7 7 0 1 0 19 15"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
          />
          <path
            d="M18.5 5.5V9H15"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ) : type === "schedule" ? (
        <svg viewBox="0 0 24 24" fill="none" className="size-5">
          <circle
            cx="12"
            cy="12"
            r="7.5"
            stroke="currentColor"
            strokeWidth="1.8"
          />
          <path
            d="M12 8v4l2.8 1.8"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ) : (
        <svg viewBox="0 0 24 24" fill="none" className="size-5">
          <path
            d="M6 7.5 12 4l6 3.5-6 3.5-6-3.5Zm0 4.5 6 3.5 6-3.5M6 16.5l6 3.5 6-3.5"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="m12 9.5-1.4 2.6h1.8L11 14.5l3-3.2h-1.8L13.6 9.5H12Z"
            fill="#a8f35a"
          />
        </svg>
      )}
    </span>
  );
}
export function ProductGlyph({
  type,
}: {
  type: "app" | "database" | "git" | "container" | "domain" | "backup";
}) {
  return (
    <span
      aria-hidden
      className="grid size-11 shrink-0 place-items-center rounded-xl bg-cloud text-moss"
    >
      {type === "database" ? (
        <svg viewBox="0 0 24 24" fill="none" className="size-6">
          <ellipse
            cx="12"
            cy="5.5"
            rx="6.5"
            ry="3"
            stroke="currentColor"
            strokeWidth="1.8"
          />
          <path
            d="M5.5 5.5v6c0 1.7 2.9 3 6.5 3s6.5-1.3 6.5-3v-6M5.5 11.5v6c0 1.7 2.9 3 6.5 3s6.5-1.3 6.5-3v-6"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
          />
        </svg>
      ) : type === "git" ? (
        <svg viewBox="0 0 24 24" fill="none" className="size-6">
          <circle cx="7" cy="6" r="2" stroke="currentColor" strokeWidth="1.8" />
          <circle
            cx="17"
            cy="12"
            r="2"
            stroke="currentColor"
            strokeWidth="1.8"
          />
          <circle
            cx="7"
            cy="18"
            r="2"
            stroke="currentColor"
            strokeWidth="1.8"
          />
          <path
            d="M9 6h2a4 4 0 0 1 4 4M7 8v8"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
          />
        </svg>
      ) : type === "container" ? (
        <svg viewBox="0 0 24 24" fill="none" className="size-6">
          <rect
            x="4"
            y="5"
            width="16"
            height="14"
            rx="2"
            stroke="currentColor"
            strokeWidth="1.8"
          />
          <path
            d="M8 9h.01M11 9h.01M14 9h.01M8 13h.01M11 13h.01M14 13h.01M18 10v4"
            stroke="currentColor"
            strokeWidth="2.4"
            strokeLinecap="round"
          />
        </svg>
      ) : type === "domain" ? (
        <svg viewBox="0 0 24 24" fill="none" className="size-6">
          <circle
            cx="12"
            cy="12"
            r="8"
            stroke="currentColor"
            strokeWidth="1.8"
          />
          <path
            d="M4 12h16M12 4c2.2 2.2 3.2 4.9 3.2 8S14.2 17.8 12 20c-2.2-2.2-3.2-4.9-3.2-8S9.8 6.2 12 4Z"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
          />
        </svg>
      ) : type === "backup" ? (
        <svg viewBox="0 0 24 24" fill="none" className="size-6">
          <path
            d="M18 9a6.5 6.5 0 1 0 1 6.8"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
          />
          <path
            d="M18 5v4h-4"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ) : (
        <svg viewBox="0 0 24 24" fill="none" className="size-6">
          <rect
            x="4"
            y="4"
            width="16"
            height="16"
            rx="3"
            stroke="currentColor"
            strokeWidth="1.8"
          />
          <path
            d="m9 9 3 3-3 3M15 15h-3"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )}
    </span>
  );
}
